module.exports = __webpack_public_path__ + "img/sus_users_John.6e38945a.png";